import './index.css';
import Routing from 'routes/Routing';
import { useSelector, useDispatch } from 'react-redux';
import { decodeToken } from 'utils/DecodeToken';
import { loggedOut } from 'reduxStore/authSlice';
import { isAreaAdmin, isSuperAdmin, isAdmin, isUser } from 'utils/utils';
import { ThemeProvider, createTheme } from '@mui/material/styles';

const theme = createTheme();

const App = () => {
  const { authToken, authExpireTime, userData } = useSelector((store) => store.auth);

  if (authToken) {
    if (isAreaAdmin(userData?.roles) || isSuperAdmin(userData?.roles)) {
      window.location.redirect = '/Stores';
    }
    if (isAdmin(userData?.roles) || isUser(userData?.roles)) {
      window.location.redirect = '/StoreInfo/projects';
    }
  } else {
    window.location.redirect = '/login';
  }

  const dispatch = useDispatch();
  const decodedToken = decodeToken(authToken);

  authToken &&
    setInterval(() => {
      const date = new Date();
      const authLoginTime = Math.floor(date.getTime() / 1000);
      if (decodedToken) {
        if (authLoginTime > authExpireTime) {
          dispatch(loggedOut());
          window.location.href = '/login';
        }
      }
    }, 1000);

  return (
    <ThemeProvider theme={theme}>
      <Routing />
    </ThemeProvider>
  );
};

export default App;
